module.exports = __webpack_public_path__ + "static/media/confettis-preview.0d5f48ce.svg";